// Shows all achievements (locked / unlocked) in a scrollable grid.

import type { Scene } from "../engine/scene/SceneManager";
import type { Game } from "../game/Game";
import { ACHIEVEMENTS } from "../game/achievements";
import { MainMenuScene } from "./MainMenuScene";

export class AchievementsScene implements Scene {
  private root!: HTMLDivElement;

  constructor(private game: Game, private onBack?: () => void) {}

  enter(): void {
    const store = this.game.achievements.store;
    const unlocked = ACHIEVEMENTS.filter((a) => store.isUnlocked(a.id)).length;

    this.root = document.createElement("div");
    this.root.className = "ach-scene";

    this.root.innerHTML = `
      <div class="ach-scene-header">
        <div class="ach-scene-title">ACHIEVEMENTS</div>
        <div class="ach-scene-count">${unlocked} / ${ACHIEVEMENTS.length}</div>
      </div>
      <div class="ach-grid" id="ach-grid"></div>
      <div class="ach-scene-footer">
        <button class="btn btn-sm ach-back-btn" id="ach-back">BACK</button>
      </div>
    `;

    const grid = this.root.querySelector("#ach-grid") as HTMLDivElement;
    const sorted = [...ACHIEVEMENTS].sort((a, b) => {
      const aU = store.isUnlocked(a.id) ? 0 : 1;
      const bU = store.isUnlocked(b.id) ? 0 : 1;
      return aU - bU;
    });
    for (const def of sorted) {
      const isUnlocked = store.isUnlocked(def.id);
      const card = document.createElement("div");
      card.className = `ach-card ${isUnlocked ? "ach-unlocked" : "ach-locked"}`;

      let progressHtml = "";
      if (!isUnlocked && def.target != null) {
        const current = store.getProgressValue(def);
        const pct = Math.min(100, (current / def.target) * 100);
        const BARS = 8;
        const filled = Math.round((pct / 100) * BARS);
        const bar = "█".repeat(filled) + "░".repeat(BARS - filled);
        progressHtml = `
          <div class="ach-progress-bar">[${bar}]</div>
          <div class="ach-progress-label">${current.toLocaleString()} / ${def.target.toLocaleString()}</div>
        `;
      }

      card.innerHTML = `
        <div class="ach-card-icon">${isUnlocked ? def.icon : "🔒"}</div>
        <div class="ach-card-title">${def.title}</div>
        <div class="ach-card-desc">${def.description}</div>
        ${progressHtml}
      `;
      grid.appendChild(card);
    }

    this.root.querySelector("#ach-back")!.addEventListener("click", () => {
      if (this.onBack) {
        this.onBack();
      } else {
        this.game.sceneManager.transition(new MainMenuScene(this.game));
      }
    });

    this.game.sceneRoot.appendChild(this.root);
  }

  exit(): void {
    this.root?.remove();
  }

  update(_dt: number): void {}
  render(_ctx: CanvasRenderingContext2D): void {}
}
